<script setup>
// imports
import {ref, reactive, onMounted} from 'vue'
import {useCartStore} from "../stores/CartStore";
import {modalStore} from "../stores/ModalStore";
import VueMagnifier from '@websitebeaver/vue-magnifier';
import '@websitebeaver/vue-magnifier/styles.css';

const cartStore = useCartStore();
const article = modalStore.article;
const category = modalStore.category;

import api from '../api';
import ToastComponent from "./ToastComponent.vue";

// data
const count = ref(0);
const data = reactive({
    articleDetail: null
})

const currentUrl = window.location.pathname
const parts = currentUrl.split("/");
const slug = parts[parts.length - 1];
const isLoading = ref(true);

onMounted(async () => {
    await cartStore.checkLoginStatus();
    if (modalStore.article) {
        const path = `/api/articles/show-article-detail/${modalStore.article.slug}`;
        try {
            const response = await api.get(path);
            if (response.data) {
                data.articleDetail = response.data;
                // Verschiebe die Carousel-Initialisierung in ein setTimeout,
                // um sicherzustellen, dass das DOM aktualisiert wurde
                setTimeout(() => {
                    const carouselId = '#carousel-article-detail';
                    const myCarousel = document.querySelector(carouselId);
                    if (myCarousel) {
                        new bootstrap.Carousel(myCarousel);
                    } else {
                        console.error('Carousel element not found');
                    }
                }, 0);
            }
        } catch (error) {
            console.error('Failed to fetch article: ', error);
        }
    }
    isLoading.value = false;
})

function addToCart() {
    if (count.value > 0) {
        if (data.articleDetail && data.articleDetail.articleimage) {
            data.articleDetail.imagedir = data.articleDetail.articleimage.imagedir;
            data.articleDetail.image = data.articleDetail.articleimage.image;
        }
        cartStore.addArticles(count.value, data.articleDetail);
        count.value = 0;
    }
}
</script>
<template>
    <div v-if="!isLoading">
        <ToastComponent>
        </ToastComponent>
        <div class="container">
            <div v-if="modalStore.category" class="row mt-5 mb-5">
                <div class="col">
                    <h1>{{ modalStore.category }}</h1>
                </div>
            </div>
            <div class="row mb-5">
                <div class="col-md-4 col-10 offset-1">
                    <div id="carousel-article-detail" class="carousel slide" data-bs-theme="dark">
                        <div class="carousel-indicators">
                            <button v-for="(sliderimage, index) in data.articleDetail?.sliderimages"
                                    type="button"
                                    data-bs-target="#carousel-article-detail"
                                    :data-bs-slide-to="index"
                                    :class="{ active: index === 0 }"
                                    :aria-current="(index === 0) ? true : null"
                                    :aria-label="'Bild ' + (index + 1)"></button>
                        </div>
                        <div class="carousel-inner">
                            <div v-for="(sliderimage, index) in data.articleDetail?.sliderimages"
                                 class="carousel-item"
                                 :class="{ active: index === 0 }">
                                <img
                                    :src="'/images/' + sliderimage.imagedir + sliderimage.image + '?w=600&h=450&fit=fill'"
                                    class="img-fluid"
                                    :class="{
                         'bg-offline': data.articleDetail.offline === true,
                         'bg-ordered': data.articleDetail.state === 2,
                     }"
                                />
                            </div>
                        </div>
                        <button class="carousel-control-prev" type="button" data-bs-target="#carousel-article-detail"
                                data-bs-slide="prev">
                            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span class="visually-hidden">Zurück</span>
                        </button>
                        <button class="carousel-control-next" type="button" data-bs-target="#carousel-article-detail"
                                data-bs-slide="next">
                            <span class="carousel-control-next-icon" aria-hidden="true"></span>
                            <span class="visually-hidden">Vor</span>
                        </button>
                        <div v-if="data.articleDetail?.badge" class="article-badge">
                            <img v-if="data.articleDetail?.badge === 'new'" :src="'/img/new_product.svg'"
                                 alt="NEW Product"
                                 class="img-fluid"/>
                            <img v-else-if="data.articleDetail?.badge === 'top'" :src="'/img/top_seller.svg'"
                                 alt="TOP Seller"
                                 class="img-fluid"/>
                        </div>
                        <div v-if="data.articleDetail?.supplier.badge" class="supplier-badge">
                            <img
                                :src="'/img/' + data.articleDetail?.supplier.badgedir + data.articleDetail?.supplier.badge"
                                :alt="data.articleDetail?.supplier.name"
                                class="img-fluid"/>
                        </div>
                    </div>
                </div>
                <div class="offset-md-1 col-md-6 col-12 mt-5">
                    <p>
                        <span class="small">ARTIKELNUMMER</span><br>
                        <strong>{{ data.articleDetail?.articlenumber }}</strong>
                    </p>
                    <h2>{{ data.articleDetail?.name }}</h2>
                    <div v-html="data.articleDetail?.description"/>

                    <p v-if="data.articleDetail?.color && data.articleDetail?.color.colorname">{{
                            data.articleDetail?.color.colorname
                        }}</p>
                    <p v-if="data.articleDetail?.discount" class="discount-red">{{
                            (1 * data.articleDetail?.rentalprice_discounted).toLocaleString('de-CH', {
                                style: 'currency',
                                currency: 'CHF'
                            })
                        }} / {{ data.articleDetail?.discount }}%<br>
                        <s>{{
                                (1 * data.articleDetail?.rentalprice).toLocaleString('de-CH', {
                                    style: 'currency',
                                    currency: 'CHF'
                                })
                            }}</s></p>
                    <p v-else>
                        <strong>{{
                                (1 * data.articleDetail?.rentalprice).toLocaleString('de-CH', {
                                    style: 'currency',
                                    currency: 'CHF'
                                })
                            }}</strong>
                    </p>
                    <p v-if="typeof data.articleDetail.quantity === 'number'">
                        <span class="discount-red">{{ data.articleDetail.quantity }} Stück auf Lager</span>
                    </p>
                    <p v-if="data.articleDetail?.brand">
                        <strong>Brand</strong>&nbsp;<span v-if="!data.articleDetail?.brand.logo">
                    {{ data.articleDetail?.brand.name }}
                </span>
                        <span v-else>
                        <img
                            :src="'/images/' + data.articleDetail?.brand.logodir + data.articleDetail?.brand.logo + '?h=50'"
                            class="img-fluid">
                    </span>
                    </p>
                    <p v-if="data.articleDetail?.material">
                        <strong>Material</strong>&nbsp;<span>
                    {{ data.articleDetail?.material.materialtype }}
                </span>
                    </p>
                    <div class="d-flex align-items-center mb-3" v-if="data.articleDetail?.materialsample">
                        <div class="flex-shrink-0">
                            <VueMagnifier
                                zoomFactor="4"
                                :src="'/images/'
                            + data.articleDetail?.materialsample.imagedir
                            + data.articleDetail?.materialsample.image
                            + '?h=50'"
                                :zoomImgSrc="'/images/'
                        + data.articleDetail?.materialsample.imagedir
                        + data.articleDetail?.materialsample.image
                        + '?h=200'"
                                :height="50">
                            </VueMagnifier>
                        </div>
                        <div class="flex-grow-1 ms-3">
                            <strong>Materialprobe</strong>&nbsp;<span>
                        {{ data.articleDetail?.materialsample.description }}
                    </span>
                        </div>
                    </div>

                    <div class="mb-3">
                        <input v-model="count" type="number" min="0" v-on:keyup.enter="addToCart" class="form-control"/>
                        <button class="btn btn-success ms-2" role="button"
                                aria-label="Warenkorb" title="zum Warenkorb hinzufügen"
                                @click="addToCart">
                            in den Warenkorb
                        </button>
                    </div>
                    <div class="mb-3">
                        <a v-if="cartStore.role === 'admin'" :href="'/admin/articles/view/' + data.articleDetail?.id">Link
                            zum
                            Artikel</a>
                        <a v-else-if="slug !== data.articleDetail?.slug"
                           :href="'/articles/' + data.articleDetail?.slug">Link
                            zum
                            Artikel</a>
                    </div>
                </div>
            </div>
        </div>
        <section class="mb-5">
            <div class="accordion" id="articleDetailAccordion">
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingOne-articleDetail">
                        <button
                            class="accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseOne-articleDetail"
                            aria-expanded="true"
                            aria-labelledby="headingOne-articleDetail"
                            aria-controls="collapseOne-articleDetail"
                        >
                            Gewicht und Grössen
                        </button>
                    </h2>
                    <div
                        id="collapseOne-articleDetail"
                        class="accordion-collapse collapse show"
                        data-bs-parent="#articleDetailAccordion"
                    >
                        <div class="accordion-body">
                            <table class="table">
                                <tbody>
                                <tr v-if="data.articleDetail?.netweight">
                                    <td style="width: 50%;">Artikelgewicht (kg)</td>
                                    <td>{{ parseFloat(data.articleDetail.netweight).toFixed(3) }}</td>
                                </tr>
                                <tr v-if="data.articleDetail?.articlewidth">
                                    <td>Breite (cm)</td>
                                    <td>{{ parseFloat(data.articleDetail.articlewidth).toFixed(1) }}</td>
                                </tr>
                                <tr v-if="data.articleDetail?.articledepth">
                                    <td>Tiefe (cm)</td>
                                    <td>{{ parseFloat(data.articleDetail.articledepth).toFixed(1) }}</td>
                                </tr>
                                <tr v-if="data.articleDetail?.articleheight">
                                    <td>Höhe (cm)</td>
                                    <td>{{ parseFloat(data.articleDetail.articleheight).toFixed(1) }}</td>
                                </tr>
                                <tr v-if="data.articleDetail?.seatheight">
                                    <td>Sitzhöhe (cm)</td>
                                    <td>{{ parseFloat(data.articleDetail.seatheight).toFixed(1) }}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingTwo-articleDetail">
                        <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseTwo-articleDetail"
                            aria-expanded="false"
                            aria-controls="collapseTwo-articleDetail"
                        >
                            Beschreibung Artikel
                        </button>
                    </h2>
                    <div
                        id="collapseTwo-articleDetail"
                        class="accordion-collapse collapse"
                        aria-labelledby="headingTwo-articleDetail"
                        data-bs-parent="#articleDetailAccordion"
                    >
                        <div class="accordion-body">
                            <div v-if="data.articleDetail?.description">
                                <h3>Info</h3>
                                <div v-html="data.articleDetail?.description"></div>
                            </div>
                            <div v-if="data.articleDetail?.specifications">
                                <h3>Beschreibung</h3>
                                <div v-html="data.articleDetail?.specifications"></div>
                            </div>
                            <div v-if="data.articleDetail?.properties">
                                <h3>Eigenschaften</h3>
                                <div v-html="data.articleDetail?.properties"></div>
                            </div>
                            <div v-if="data.articleDetail?.designer">
                                <h3>Designer: {{ data.articleDetail?.designer.name }}</h3>
                                <div v-html="data.articleDetail?.designer.description"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="accordion-item">
                    <h2 class="accordion-header" id="headingThree-articleDetail">
                        <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseThree-articleDetail"
                            aria-expanded="false"
                            aria-controls="collapseThree-articleDetail"
                        >
                            Downloads / Files
                        </button>
                    </h2>
                    <div
                        id="collapseThree-articleDetail"
                        class="accordion-collapse collapse"
                        aria-labelledby="headingThree-articleDetail"
                        data-bs-parent="#articleDetailAccordion"
                    >
                        <div class="accordion-body">
                            <div class="row align-items-center mt-3" v-if="data.articleDetail?.datasheet">
                                <div class="col-1">
                                    <img src="../../webroot/img/iconDocument.svg" alt="Dokument herunterladen"
                                         class="icon">
                                </div>
                                <div class="col-3">
                                    Produktblatt (pdf)
                                </div>
                                <div class="col-3">
                                    <img src="../../webroot/img/iconDownload.svg" alt="Dokument herunterladen"
                                         class="icon me-3">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<style scoped>
input {
    width: 4rem;
    text-align: center;
    display: inline-block;
}

.carousel-indicators button {
    width: .8rem;
    height: .8rem;
    border-radius: 100%;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
input[type=number] {
    -moz-appearance: textfield;
}
</style>
